<template>
  <v-app-bar
    class="main-header"
    height="64"
    fixed
    color='primary'
    dark
    >
    <v-btn icon class="mx-1" @click.stop="TOGGLE_DRAWER">
      <template v-if="DRAWER_STATE">
        <v-icon  style="font-size: 28px">mdi-arrow-left</v-icon>
      </template>
      <template v-else>
        <v-icon style="font-size: 28px">mdi-menu</v-icon>
      </template>
    </v-btn>
    <v-toolbar-title>Company Policy</v-toolbar-title>
    <v-spacer></v-spacer>

    <v-btn
        v-for="(btn, i) in buttons"
        :key="i"
        icon
        target="_blank"
        class="mr-1"
        :href=" btn.link ">
      <v-icon size="24">
        {{ btn.icon }}
      </v-icon>
    </v-btn>




  </v-app-bar>
</template>

<script>
  import {mapActions, mapState} from 'vuex'
  import config from '@/config';

  export default {
    name: 'Header',
    data: () => ({
      config,
      searchCollapse: true,
      buttons: [
      ]
    }),
    computed: {
      ...mapState('Layout', { drawer: state => state.drawer }),
      DRAWER_STATE :{
        get() {
          return this.drawer
        },
      }
    },
    methods: {
      ...mapActions('Layout', [ 'TOGGLE_DRAWER']),
    }
  };
</script>

<style src="./DocHeader.scss" lang="scss"></style>
